import i18n from 'react-intl-universal';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';
import styles from './EditorWrapper.scss';

import { Notes, NoteContent, Notebooks } from '../../constants/actionTypes';
import { getNotebooks } from '../../actions/NotebooksAction';
import { getNotes } from '../../actions/NotesAction';
import { getNoteContent } from '../../actions/NoteContentAction';
import { getState as getNotebooksState } from '../../reducers/Notebooks/NotebooksReducer';
import { getState as getNotesState } from '../../reducers/Notes/NotesReducer';
import { getState as getContentState } from '../../reducers/NoteContent/NoteContentReducer';
import { getState as getUserState } from '../../reducers/User/UserReducer';


import withLoading from '../../HOC/withLoading';
import { RichTextEditor, MarkDownEditor } from '../../components/Editor';

import { checkNoteIsInSeq, checkContent, checkNotes, keyDownResult, martinDispatch } from '../../utils/util';
import Message from '../Message/';

@withRouter
@connect(
  (state) => {
    // const globalState = getGlobalState(state);
    return {
      userInfo: getUserState(state).get('user'),
      notebooks: getNotebooksState(state),
      content: getContentState(state),
      notes: getNotesState(state),
      notesStatus: getNotesState(state).get('status'),
    };
  },
  dispatch => ({
    getNotebooks: (isForce = false) => dispatch(getNotebooks(isForce)),
    getNotes: (nbId, isForce = false, page = 1, count = 10, nid = null) => dispatch(getNotes(nbId, isForce, page, count, nid)),
    getNoteContent: (noteId, isForce = false) => dispatch(getNoteContent(noteId, isForce)),
  }),
)
@withLoading((props) => {
  const { notebooks, notesStatus, content, match } = props;
  const { params: { nbId, noteId } } = match;
  const notes = notebooks.getIn(['entities', nbId, 'notes']);
  // 如果已经获取到notebooks，且其长度为0，则移除loading
  const seq = notebooks.get('seq');
  const nbStatus = notebooks.get('status');
  // eslint-disable-next-line max-len
  if (seq && seq.size === 0 && nbStatus !== Notebooks.NOTEBOOKS_INIT && nbStatus !== Notebooks.GET_NOTEBOOKS) {
    return false;
  }
  // 从后端拿到notes且notes长度为0时，移除loading
  if (notes && notes.size === 0) {
    return false;
  }
  if (notesStatus === Notes.GET_NOTES_FAIL) {
    return false;
  }
  const contentStatus = content.getIn(['entities', noteId, 'status']);
  // 当获取失败或已经成功拿到文章时，移除loading
  // eslint-disable-next-line max-len
  return !((checkNotes(props) && checkContent(props)) || contentStatus === NoteContent.GET_NOTE_CONTENT_FAIL);
})({ tip: 'global.content-loading', hasMask: true })
export default class EditorWrapper extends Component {
  componentDidMount() {
    const { match } = this.props;
    const { params: { noteId, nbId } } = match;
    this.props.getNotebooks();
    if (nbId) {
      // 传递 noteId 作为 nid 参数
      this.props.getNotes(nbId, false, 1, 10, noteId || null);
    }
    if (noteId) {
      this.props.getNoteContent(noteId);
    }
    if (this.isWritingMode()) {
      Message.info(i18n.get('global.quit'));
    }
    // eslint-disable-next-line consistent-return
    window.onbeforeunload = (e) => {
      const isSaveFail = this.isSaveFail();
      if (isSaveFail) {
        const returnText = i18n.get('error.save-again');
        e.returnValue = returnText;
        return returnText;
      }
      // return null;
    };
  }

  componentWillReceiveProps(nextProps) {
    const isSaveFail = this.isSaveFail();
    const currId = this.props.match.params.noteId;
    const nextId = nextProps.match.params.noteId;
    // 切换文章时需要提示保存失败，需要手动保存
    if (currId && currId !== nextId && isSaveFail) {
      Message.error(i18n.get('error.save-again-soft'));
    }
  }

  // eslint-disable-next-line class-methods-use-this
  componentWillUnmount() {
    window.onbeforeunload = null;
  }

  getSaveStatus = () => {
    const { match, content } = this.props;
    const { params: { noteId } } = match;
    return content.getIn(['entities', noteId, 'updateStatus']);
  };

  isSaving = () => {
    const status = this.getSaveStatus();
    return status === Notes.UPDATE_NOTE;
  };

  isSaveFail = () => {
    const status = this.getSaveStatus();
    return status === Notes.UPDATE_NOTE_FAIL;
  };

  getSaveStatusText = () => {
    const isSaving = this.isSaving();
    const isSaveFail = this.isSaveFail();
    if (isSaving) {
      return i18n.get('pubbtn.saving');
    }
    if (isSaveFail) {
      return i18n.get('pubbtn.save-fail');
    }
    return i18n.get('pubbtn.saved');
  };

  onKeyDown = (e) => {
    const { history, match } = this.props;
    const { params: { nbId, noteId } } = match;
    const isWritingMode = this.isWritingMode();
    const result = keyDownResult(e);
    // 按下ESC
    if (result.esc) {
      if (isWritingMode) {
        history.push(`/notebooks/${nbId}/notes/${noteId}`);
        e.preventDefault();
      }
    }
  };

  getCurNoteType = () => {
    const { notes, match } = this.props;
    const { params: { noteId } } = match;
    return notes.getIn(['entities', noteId, 'note_type']);
  };

  isWritingMode = () => {
    const { match } = this.props;
    const { path } = match;
    return /\/writing\/?$/.test(path);
  };

  isRichText = () => {
    return this.getCurNoteType() === 1;
  };

  isMarkDown = () => {
    return this.getCurNoteType() === 2;
  };

  render() {
    const hasNotes = checkNotes(this.props);
    const hasContent = checkContent(this.props);
    const isValid = checkNoteIsInSeq(this.props);
    const isRichText = this.isRichText();
    const isMarkDown = this.isMarkDown();
    const isWritingMode = this.isWritingMode();
    const modeWrapClasses = classNames(styles['editor-wrapper'], {
      [styles['writing-mode']]: isWritingMode,
    });


    if (hasNotes && hasContent && isValid) {
      return (
        <div
          className={modeWrapClasses}
          tabIndex={-1}
          onKeyDown={this.onKeyDown}
          autoFocus
        >
          <p className={styles['saving-status']}>{this.getSaveStatusText()}</p>
          {isRichText &&
          <RichTextEditor
            isWritingMode={isWritingMode}
          />
          }
          {isMarkDown &&
          (
            <MarkDownEditor
              isWritingMode={isWritingMode}
              {...this.props}
            />
          )}
        </div>
      );
    }
    return (
      <div className={styles['editor-wrapper-no-notes']}>
        <span>简 书</span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EditorWrapper/EditorWrapper.js